import { jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef } from "react";
import { Tabs, cn } from "@pcln/horizon";
import { getSearchFormTabsSlotClassNames } from "./SearchFormTabs.utils.js";
import { searchFormTabs } from "./SearchFormTabs.variants.js";
function SearchFormTabsComponent({ className, showPanels = true, tabs, value, onActiveTabClick, onValueChange, slotClassNames = {}, ...props }, ref) {
    const styles = searchFormTabs();
    const listFrameRef = useRef(null);
    const resolvedSlotClassNames = getSearchFormTabsSlotClassNames({
        ...slotClassNames,
        panelClass: cn(slotClassNames.panelClass, !showPanels && 'hidden')
    });
    const tabsContent = tabs.map((tab)=>({
            ...tab,
            panelContent: showPanels ? tab.panelContent ?? null : null
        }));
    useEffect(()=>{
        const listFrame = listFrameRef.current;
        if (!listFrame || !onActiveTabClick) return;
        const handleTabListClick = (event)=>{
            if (!(event.target instanceof Element)) return;
            const tabElement = event.target.closest('[role="tab"]');
            if (!tabElement || !listFrame.contains(tabElement)) return;
            const tabElements = Array.from(listFrame.querySelectorAll('[role="tab"]'));
            const tabIndex = tabElements.indexOf(tabElement);
            const selectedTab = tabs[tabIndex];
            if (selectedTab?.value === value) onActiveTabClick(selectedTab.value, event);
        };
        listFrame.addEventListener('click', handleTabListClick);
        return ()=>{
            listFrame.removeEventListener('click', handleTabListClick);
        };
    }, [
        onActiveTabClick,
        tabs,
        value
    ]);
    return /*#__PURE__*/ jsx("div", {
        className: cn(styles.root(), className),
        ref: ref,
        ...props,
        children: /*#__PURE__*/ jsx("div", {
            className: styles.content(),
            children: /*#__PURE__*/ jsx("div", {
                className: styles.listFrame(),
                ref: listFrameRef,
                children: /*#__PURE__*/ jsx(Tabs, {
                    stacked: true,
                    tabsContent: tabsContent,
                    value: value,
                    onValueChange: (nextValue, event)=>onValueChange(nextValue, event),
                    slotClassNames: resolvedSlotClassNames
                })
            })
        })
    });
}
const SearchFormTabs = /*#__PURE__*/ forwardRef(SearchFormTabsComponent);
export { SearchFormTabs };
